import { GROUPS_CONFIG, DEFAULT_GROUP, getGroupUrlPathSegment } from '../config/uiConfig';

export { GROUPS_CONFIG, DEFAULT_GROUP, getGroupUrlPathSegment };

export const isLatestOnlyGroup = (groupName) => {
  return GROUPS_CONFIG[groupName]?.latestOnly === true;
};

/**
 * Iframe-domain groups (e.g. Clinical) present FHIR Implementation Guides in an
 * iframe instead of JSON schema tables. They are latest-only and drive their
 * own page layout via `pageLayout.byGroup`.
 */
export const isIframeDomainGroup = (groupName) => {
  return GROUPS_CONFIG[groupName]?.iframeDomain === true;
};

/**
 * Full-featured groups expose Events, Release History, Workflow, and Manage
 * Release (previously the hardcoded `isLabGroup` check).
 */
export const isFullFeaturedGroup = (groupName) => {
  return GROUPS_CONFIG[groupName]?.fullFeatured === true;
};

/**
 * Chatbot-enabled groups show the "Ask DLI Agent" assistant. Opt-in per group
 * via `chatbot: true` in uiConfig; defaults to disabled for any group that does
 * not explicitly enable it (including unknown groups).
 */
export const isChatbotEnabledGroup = (groupName) => {
  return GROUPS_CONFIG[groupName]?.chatbot === true;
};
